<template>
  <component v-if="wrapper" :is="wrapper" :action="action" :label="label" :disabled="disabled" :collect="collect" :variant="variant" :fallback="fallback" v-on="$listeners" />
  <button v-else type="button" :disabled="disabled || !fallback" @click="action">{{ label }}</button>
</template>
<script>
import extensions from '@/extensions';
export default {
  props: { fallback: { type: Boolean, default: true }, action: { type: Function, required: true }, label: String, disabled: Boolean, collect: { type: Boolean, default: true }, variant: { type: String, default: 'primary' } },
  data: () => ({ wrapper: extensions.actionButton }),
};
</script>
